import DataLoaderOverlay from "components/DataLoaderOverlay";

// Wholesale kit order form. This page is the ThriveCart embed only.
// It has no Stripe dependency: ThriveCart replaced Stripe checkout in 7ddebf3 (2025-12-08).
// Removed by mistake in 455eaee (2026-08-13) as part of the Stripe cleanup; restored here.
const THRIVECART_WHOLESALE_KIT_URL =
  "https://designergenes.thrivecart.com/61/?1=1&_embeddable=1";

type IProps = {
  isLoading: boolean;
};

const Checkout = ({ isLoading }: IProps) => (
  <DataLoaderOverlay isLoading={isLoading}>
    <div className="pt-14 bg-main font-helvetica">
      <div className="flex flex-col justify-center">
        <div className="overflow-x-auto w-full sm:w-6/12 mx-auto">
          <iframe
            src={THRIVECART_WHOLESALE_KIT_URL}
            style={{ width: "100%", height: "1200px", border: "none" }}
            scrolling="yes"
            title="Designer Genes wholesale kit order form"
          />
        </div>
      </div>
    </div>
  </DataLoaderOverlay>
);

export default Checkout;
